import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import * as API from "../../Endpoints/Endpoints"; // Ensure this path is correct

const ViewGameMaster = () => {
  const [gameMasterData, setGameMasterData] = useState(null);
  const { gamemasterid } = useParams(); // Fetch the game master ID from URL
  const navigate = useNavigate();

  useEffect(() => {
    const getGameMasterData = async () => {
      if (!gamemasterid) {
        alert('Invalid game master ID');
        return;
      }
      try {
        const response = await axios.get(API.GET_MASTER_BYID(gamemasterid)); // Adjust this endpoint as needed
        setGameMasterData(response.data); // Assuming the response is a single object
      } catch (error) {
        console.error("Error fetching game master data:", error);
        alert("Failed to load game master details.");
      }
    };
  
    if (gamemasterid) getGameMasterData();
  }, [gamemasterid]);

  const deleteGameMaster = async (gamemasterid) => {
    try {
      await axios.delete(API.DELETE_MASTER_API(gamemasterid)); // Adjust this endpoint as needed
      alert("Game Master deleted successfully");
      navigate("/gamemastertable"); // Navigate back to game master list
    } catch (error) {
      alert("Failed to delete game master");
      console.error("Error deleting game master:", error.response ? error.response.data : error.message);
    }
  };

  const goBack = () => {
    navigate("/gamemastertable"); // Navigate back to the game master table
  };

  return (
    <div className="py-16 bg-[#f5f5f5] h-full">
      <div className="container px-6 m-auto text-gray-700 md:px-12 xl:px-0">
        <div className="grid gap-6 mx-auto md:w-3/6 lg:w-full lg:grid-cols-1">
          <div className="bg-white rounded-2xl shadow-lg px-8 py-12 sm:px-12 lg:px-8">
            <div className="mb-12 space-y-6">
              {gameMasterData ? (
                <div>
                  <h5 className="text-2xl font-semibold text-[#e64a32]">
                    Game Master Details
                  </h5>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    <div className="flex flex-col">
                      <span className="font-bold">Game Category</span>
                      <span>{gameMasterData.gamecategory}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Name</span>
                      <span>{gameMasterData.gamename}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Code</span>
                      <span>{gameMasterData.gamecode}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Symbol</span>
                      <span>{gameMasterData.gamesymbol}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Game Board Type</span>
                      <span>{gameMasterData.gameboardtype}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="font-bold">Complexity</span>
                      <span>{gameMasterData.complexity}</span>
                    </div>
                  </div>
                  <div className="flex items-center justify-center mt-6 space-x-4">
                    <button
                      className="bg-[#e64a32] text-white hover:bg-[#e64a32] font-bold py-2 px-4 rounded"
                      onClick={() => deleteGameMaster(gameMasterData.gamemasterid)}
                    >
                      Delete
                    </button>
                    <button
                      className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded"
                      onClick={goBack}
                    >
                      &#8592; Go Back
                    </button>
                  </div>
                </div>
              ) : (
                <p className="text-center text-gray-500">Loading game master details...</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewGameMaster;
